import { useSearchParams } from "react-router-dom";

import { ChatPage, HeaderDetailProject, SourceList } from "./components";
import { useEffect, useState } from "react";
import { getDetailProject } from "services";
import { Project } from "interfaces";
import { useAppDispatch } from "store/store";
import { setCurrentProject } from "store/slicer/GestioneProjectsSlice";
import { useUnmountEffect } from "primereact/hooks";
import { resetInitialStateSaveAnswer } from "store/slicer/GestioneSaveAnswerSlice";

export const DetailProjectPage = () => {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const [projectId, setProjectId] = useState("");
  const [project, setProject] = useState<Project | null>(null);

  useUnmountEffect(() => {
    dispatch(resetInitialStateSaveAnswer());
  });

  useEffect(() => {
    const urlProjectId = searchParams.get("id");
    if (urlProjectId) {
      setProjectId(urlProjectId);
      if (urlProjectId) {
        getDetailProject(urlProjectId)
          .then((response) => {
            setProject(response.data);
            dispatch(setCurrentProject(response.data as any));
          })
          .catch((_) => {});
      }
    }
  }, [searchParams, dispatch]);

  return (
    <>
      <div className="height-px-76 bg-white">
        <HeaderDetailProject project={project!} projectId={projectId} />
      </div>
      <div></div>
      <div className="container-content">
        <SourceList projectId={projectId} />
        <ChatPage projectId={projectId} />
      </div>
    </>
  );
};
